module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_250_Active@1x-67da465ad4492457cc866d59863f63e2.png";